import React, { useReducer } from 'react'
import { Container, Row, Col, Card, ToggleButton, } from 'react-bootstrap'



export function Tunnesana() {
const [state, dispatch] = useReducer(reducer, {}, initState)
const selected  = state === null ? null : state.vireys_sana 
return (
	<Card style={{'margin':'1rem'}}>
	<Card.Header>Tunnesana</Card.Header>
	<Card.Body>
	<Container fluid style={{'maxWidth': '1100px'}}>
	<Row>
	{tunnesanat.map((sana, idx) => {
		return (
			<Col key={idx} xs='auto' style={{'paddingBottom': '0.5rem', 'paddingLeft': '0', 'paddingRight': '0.5rem'}}>
			<ToggleButton id={idx} variant='outline-primary' type='checkbox' 
				name={sana} value={sana} checked={sana===selected} 
				onChange={(e) => dispatch({type: 'vireys_sana', payload: e.target.value})} >{sana}</ToggleButton>
			</Col>
		)
	})}	
	</Row>
	</Container>
	</Card.Body>
	</Card>
)
}


export function initState() {
	return {
		vireys_sana: null,
	}
}



export function reducer(state, action) {
	console.log('reducer', state, action)
	const newState = { ...state }
	switch(action.type) {
		case 'vireys_sana':
			newState.vireys_sana = action.payload
			break
		default:
			return state
	}
	return newState	
}



export const tunnesanat = [
	'ainutlaatuinen', 'luottavainen', 'ahdistunut','pahoillaan',
	'antelias','myötätuntoinen','alakuloinen','pelokas',
	'arvokas','nuorekas','arka','pelästynyt',
	'arvostettu','onnellinen','avuton','pessimistinen',
	'elävä','peloton','ennakkoluuloinen','pettynyt',
	'erityinen','pätevä','epäluuloinen','pitkästynyt',
	'haluttava','rakastava', '	epäpätevä', 'päättämätön',
	'hellä', 'rakastettava', 'epätoivoinen', 'raivostunut',
	'helpottunut', 'rakastettu', 'epävarma', 'rasittunut',
	'hiljainen', 'rauhallinen', 'eristynyt', 'raskasmielinen',
	'humoristinen', 'rento', 'estynyt', 'rauhaton',
	'hupsu', 'riemastunut', 'hajamielinen', 'riippuvainen',
	'huvittunut', 'riemukas', 'halveksiva', 'riittämätön',
	'hyväksytty', 'rohkea', 'harmistunut', 'riutunut',
	'hyvillään', 'seksikäs', 'hermostunut', 'ruma',
	'hyvinvoiva', 'sovinnollinen', 'huolestunut', 'sorrettu',
	'hyvä', 'sydämellinen', 'hyväksikäytetty', 'suojaton',
	'hyväntuulinen', 'toiveikas', 'hyödytön', 'surkea',
	'ihana', 'turvallinen', 'hädissään', 'surullinen',
	'ilahtunut', 'tyyni', 'hämillään', 'suunniltaan',
	'iloinen', 'tyytyväinen', 'hämmentynyt', 'suuttunut',
	'innokas', 'upea', 'häpeissään', 'syyllinen',
	'innostunut', 'utelias', 'häpäisty', 'säikky',
	'intohimoinen', 'vahva', 'hölmö', 'teennäinen',
	'kaunis', 'varma', 'itsepäinen', 'toivoton',
	'kiitollinen', 'vilpitön', 'jumiutunut', 'torjuttu',
	'kunnioitettu', 'välittävä', 'järkyttynyt', 'turhautunut',
	'kyvykäs', 'ylpeä', 'katkera', 'turvaton',
	'leikkisä', 'ymmärtävä', 'katuvainen', 'tympääntynyt',
	'lempeä', 'ystävällinen', 'kauhistunut', 'typerä',
	'luotettava', 'älykäs', 'kaunainen', 'uhattu',
	'kiihtynyt', 'ujo', 'Kiusaantunut', 'uupunut', 'kärsimätön', 'vaivautunut', 'kömpelö', 
	'vanha', 'laiminlyöty', 'vastenmielinen', 'lannistunut', 'vihamielinen', 'levoton', 
	'vimmastunut', 'loukkaantunut', 'väheksytty', 'masentunut', 'vähäarvoinen', 'mitätön', 
	'väsynyt', 'musertunut', 'väärinymmärretty', 'mustasukkainen', 'yksinäinen', 
	'nolo', 'ymmällään', 'nynny', 'äreä', 'nöyryytetty', 'ärtynyt'
]